module.exports = __webpack_public_path__ + "static/media/Outdoors.a7103c96.png";